import { ApiResponse } from 'apisauce';
import { IPaginationSnapshot } from 'src/models/pagination/Pagination';
import { IResponseSnapshot } from 'src/models/response/Response';

import { IDept, IDeptFilter, IDeptSnapshot, IDeptTree } from '../../models';
import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import {
  TDeleteDeptResult,
  TGetDeptResult,
  TGetDeptsResult,
  TGetDeptTreeResult,
  TPostDeptResult,
  TUpdateDeptResult,
} from './DeptTypes';

/**
 * # Dept Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new DeptApi();
 *
 * ```
 */
export class DeptApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getTree(menuSid?: number): Promise<TGetDeptTreeResult> {
    try {
      const url = `/v1/dept/tree`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url, { menuSid: menuSid });

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const deptTree: IDeptTree[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', deptTree, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async gets(paging: IPaginationSnapshot, filter?: IDeptFilter): Promise<TGetDeptsResult> {
    try {
      const url = `/v1/dept?page=${paging.page}&size=${paging.size}`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url, filter);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const depts: IDept[] = response.data.data;
      const pagination: IPaginationSnapshot = response.data.pagination;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', depts, pagination, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async get(id: number): Promise<TGetDeptResult> {
    try {
      const url = `/v1/dept/${id}`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const dept: IDept = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', dept, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async post(data: IDeptSnapshot): Promise<TPostDeptResult> {
    try {
      const url = '/v1/dept';
      const response: ApiResponse<any> = await this.api.apisauce.post(url, data);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const dept: IDept = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', dept, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async update(data: IDeptSnapshot): Promise<TUpdateDeptResult> {
    try {
      const url = `/v1/dept/${data.deptSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.put(url, data);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const dept: IDept = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', dept, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async delete(id: number): Promise<TDeleteDeptResult> {
    try {
      const url = `/v1/dept/${id}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
